@use "ui/styles/fonts";

.wrapper {
  background-color: transparent;
  border-color: transparent;
}
